import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowFormComponent } from './flow-form.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormWithoutRoutingModule } from 'src/app/form/form-without-routing.module';

@NgModule({
  declarations: [
    FlowFormComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormWithoutRoutingModule
  ],
  exports: [
    FlowFormComponent
  ]
})
export class FlowFormModule { }